export const OptionYears = [
  { id: 'less_than_1_year', name: 'Less than 1 year', code: '0' },
  { id: '1_year', name: '1 year', code: '1' },
  { id: '2_year', name: '2 years', code: '2' },
  { id: '3_year', name: '3 years', code: '3' },
  { id: '4_year', name: '4 years', code: '4' },
  { id: '5_year', name: '5 years', code: '5' },
  { id: 'More_than_5_year', name: 'More than 5 years', code: '6' }
];

export const OptionAnnualTrades = [
  { id: '10_trades_or_less', name: '10 trades or less', code: '10' },
  { id: '11_to_25_trades', name: '11 to 25 trades', code: '25' },
  { id: '26_to_50_trades', name: '26 to 50 trades', code: '50' },
  { id: '51_or_more_trades', name: '51 or more trades', code: '51' }
];


export const OptionAverageTradeSize = [
  { id: '1000_or_less', name: '$1,000 or less', code: '1000' },
  { id: '1001_5000', name: '$1,001 - $5,000', code: '5000' },
  { id: '5001_25000', name: '$5,001 - $25,000', code: '25000' },
  { id: '25001_or_more', name: '$25,001 or more', code: '25001' }
];
